import React, {Component} from 'react'
import PropTypes from 'prop-types'
import humanizeTime from '../../../../../helpers/time/humanizeTime'

class BasketCreated extends Component {
    render() {
        const {created} = this.props
        const textTime = created ? humanizeTime(created) : '-'

        return (
            <td className='BasketCreated'>
                {textTime}
            </td>
        )
    }
}

BasketCreated.propTypes = {
    created: PropTypes.string.isRequired,
}

export default BasketCreated
